import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";
import { logError } from "../common/utils/logger";


const encryptFormDataFields = (formData) => {
  const app = formData.get("applicationNumber");

  if (app != null && String(app).trim() !== "") {
    formData.set(
      "applicationNumber",
      encryptJourneyQueryValue(String(app))
    );
  }

  const dobField = ["dateOfBirth", "dob", "liDob"].find(
    (field) => formData.get(field) != null
  );

  const dob = dobField ? formData.get(dobField) : null;

  if (dob != null && String(dob).trim() !== "") {
    formData.set(
      dobField,
      encryptJourneyQueryValue(String(dob))
    );
  }
};

export const uploadDocument = async (formData) => {
  try {
    if (
      typeof FormData !== "undefined" &&
      formData instanceof FormData
    ) {
      encryptFormDataFields(formData);
    }

    const response = await api.post(
      API_ENDPOINTS.DOCUMENT_UPLOAD,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response?.data ?? null;
  } catch (error) {
    logError("Document upload failed", error);
    throw error;
  }
};